export default {
      id: "camera-usage",
      viewBox: "0 0 33.786 33.785",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#camera",
      toString: function () {
        return this.url;
      }
    }